import { Card } from '@modusign/design-system';

import AddressBookSearchFilterProvider from '../AddressBookSearchFilterProvider';
import SettingsAddressBookPageHeader from '../SettingsAddressBookPageHeader';
import ContactList from './ContactList';

export default function SettingsAddressBookPage() {
  return (
    <AddressBookSearchFilterProvider>
      <Card>
        <SettingsAddressBookPageHeader />
        <ContactList />
      </Card>
    </AddressBookSearchFilterProvider>
  );
}
